<div class="page-content page-fill">
  <!-- <div class="card mb-3">
  <div class="card-body">
    <dx-form [formData]="filter" style="max-width: 400px" *ngIf="filter">
      <dxi-item [label]="{ text: 'Statuses' }" *ngIf="filter">
        <div *dxTemplate>
          <dx-select-box
            [(value)]="filter.statusId"
            [items]="statuses"
            valueExpr="id"
            displayExpr="name"
            (onValueChanged)="onValueChanged($event)"
          ></dx-select-box>
        </div>
      </dxi-item>
    </dx-form>
  </div>
</div> -->
<div class="card mb-3">
  <div class="card-body">
    <div class="row">
      @if (filter) {
        <dx-form [formData]="filter" [colCount]="2" style="max-width: 600px">
          <dxi-item>
            <button type="button" (click)="login()" class="btn btn-login" style="margin-right: 50px;" [disabled]="processing">
              {{ 'Login' }}
            </button>
          </dxi-item>
          <dxi-item>
            <button type="button" (click)="login('logout')" class="btn btn-logout" [disabled]="processing">
              {{ 'Logout' }}
            </button>
          </dxi-item>
        </dx-form>
      }
    </div>
  </div>
</div>
<div class="grid-fill">
  <dx-data-grid
    #dataGrid
    [dataSource]="people"
    keyExpr="id"
    [showBorders]="true"
    [wordWrapEnabled]="true"
    [rowAlternationEnabled]="false"
    (onToolbarPreparing)="onToolbarPreparing($event)"
    >
    <dxi-column dataField="displayNameLastFirst" caption="Child Name" [width]="250" cellTemplate="linkTemplate"></dxi-column>
    <dxi-column dataField="personStatus.name" caption="Status" [width]="200"></dxi-column>
    <!-- <dxi-column dataField="displayNameLastFirst" caption="Parent/Guardian Name" [width]="250" cellTemplate="linkTemplate"></dxi-column> -->
    <dxi-column dataField="cellPhone" caption="Phone" [width]="200"></dxi-column>
    <dxi-column dataField="pager" caption="Pager" [width]="90"></dxi-column>
    <dxi-column dataField="notes" caption="Notes" [width]="400"></dxi-column>

    <!-- <dxi-column dataField="family.familyStatus.name" caption="Family Status" [width]="200"></dxi-column>
    <dxi-column dataField="displayAddress" caption="Address" [width]="550"></dxi-column>
    <dxi-column dataField="homePhone" caption="Phone" [width]="200"></dxi-column> -->

    <div *dxTemplate="let cell of 'linkTemplate'">
      <a [routerLink]="" (click)="open(cell.data)">{{ cell.value || '(blank)' }}</a>
    </div>

    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-remote-operations [sorting]="true" [filtering]="true"></dxo-remote-operations>
    <dxo-selection mode="multiple"></dxo-selection>
    <dxo-state-storing [enabled]="true" type="sessionStorage" storageKey="householdVisitGrid"></dxo-state-storing>
    <dxo-search-panel [visible]="true"></dxo-search-panel>

    <div *dxTemplate="let data of 'toolbarButtons'">
      <!-- <button
      (click)="updateStatus('Person')"
      class="btn btn-primary"
      [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
      >
      Update Member Status
    </button>
    <button
      (click)="updateStatus('Family')"
      class="btn btn-primary ms-4"
      [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
      >
      Update Family Status
    </button> -->
    <!-- <button
    (click)="quickVisit(dataGrid.instance.getSelectedRowsData())"
    class="ms-2 btn btn-danger"
    [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
    >
    Quick Log
  </button> -->
  <!-- <button (click)="addVisit(dataGrid.instance.getSelectedRowsData()[0])" class="ms-2 btn btn-secondary" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">
  Open
</button> -->
</div>
</dx-data-grid>
</div>
</div>
